// src/reducers/customersReducer.js
import { createListReducer } from "./createListReducer";

export const initialState = {
  customers: [],
  loading: false,
  error: '',
  order: 'asc', // 'asc' or 'desc'
  orderBy: 'lastName', // default sort column
  page: 0, // zero-based index
  rowsPerPage: 25,
  totalCustomers: 0,
};

export const customersReducer = createListReducer('customers', 'totalCustomers');